var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphic1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 125,
    viewBox: "0 0 192 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.863 62.8754C137.931 62.8754 145.921 61.2664 153.375 58.1403C160.829 55.0143 167.601 50.4323 173.306 44.6561C179.011 38.8799 183.537 32.0225 186.624 24.4755C189.712 16.9285 191.301 8.83971 191.301 0.670901L129.863 0.670898L129.863 62.8754Z",
    fill: "#FEB449"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.238 62.1494C130.238 54.079 128.629 46.0877 125.504 38.6316C122.379 31.1755 117.798 24.4008 112.024 18.6941C106.249 12.9875 99.3937 8.46078 91.8488 5.37238C84.3039 2.28397 76.2174 0.694389 68.0509 0.694389V62.1494H130.238Z",
    fill: "#FEB449"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M191.301 124.329C183.233 124.329 175.244 122.721 167.79 119.594C160.336 116.468 153.563 111.886 147.858 106.11C142.153 100.334 137.627 93.4766 134.54 85.9296C131.452 78.3826 129.863 70.2938 129.863 62.125L191.301 62.125L191.301 124.329Z",
    fill: "#FEB449"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.863 61.774C121.795 61.774 113.806 63.383 106.352 66.5091C98.8981 69.6352 92.1253 74.2171 86.4202 79.9933C80.7152 85.7695 76.1897 92.6269 73.1022 100.174C70.0147 107.721 68.4255 115.81 68.4255 123.979L129.863 123.979L129.863 61.774Z",
    fill: "#FEB449"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.122 124.329V93.0082L58.0916 62.125V93.0082L28.122 124.329Z",
    fill: "#79C3AA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.698853 124.329V93.0082L29.17 62.125V93.0082L0.698853 124.329Z",
    fill: "#79C3AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphic1);
export default __webpack_public_path__ + "static/media/graphic_1.fa310329c21f3a679d7749384fee60eb.svg";
export { ForwardRef as ReactComponent };